import React, { useEffect, useState } from "react";
import "./AddressDetails.css";
import { GoPlus } from "react-icons/go";
import { Modal, Button, Form } from "react-bootstrap";
import { Apiurl } from "../../Pages/utils/page";
const AddressDetails = ({
  vendorBannerAnalytic,
  updateIndex,
  setUpdateIndex,
  setHideButton,
  hideButton,
  setBannerUrl,
  showSaveButton,
  setShowSaveButton,
  handleSaveBanner,
  formData,
  setAddress,
  Address,
  handleAddAddress,
  handleRemoveDeliveryAddress,
  show,
  handleClose,
  handleShow,
  DeliveryAddressList,
  handleEditaddress,
  PrefiledData = { PrefiledData },
  UpdateDefaultDeliveryAddress,
}) => {
  const [bannerPreview, setBannerPreview] = useState();
  // const [Address, setAddress ] = useState({
  //   name: '',
  //   mobile: '',
  //   pincode: '',
  //   address: '',
  //   locality: '',
  //   city: '',
  //   state: '',
  //   landmark: '',
  //   altPhone: '',
  // });

  const [selectedAddress, setSelectedAddress] = useState(null);
  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  };
  const handleBannerUpload = (e) => {
    getBase64(e, (result) => {
      setBannerUrl(result);
    });
    const objectUrl = URL.createObjectURL(e);
    setBannerPreview(objectUrl);
    setShowSaveButton(true);
  };

  return (
    <>
      <div className="mt-4">
        <h4>Address Details </h4>
        <hr />
        <div className="row">
          <div className="Add-address-flex-container">
            <div className="Saved-heading">
              <h3>Saved Addresses </h3>
            </div>
            <div className="Add-New-Address-container">
              <button
                type="button"
                onClick={() => {
                  handleShow();
                }}
              >
                <GoPlus /> Add New Address
              </button>
            </div>
          </div>
          {DeliveryAddressList?.map((addressItem, index) => {
            return (
              <div className="Your-Address-detail-main-container">
                <div
                  key={index}
                  className="Your-Address-detail-Outter-container"
                >
                  <h4>
                    {addressItem.PhoneNumber},   {addressItem?.AreaAndStreet},   {addressItem?.Locality}   {addressItem?.Landmark},   {addressItem?.City}   {addressItem?.State}   {addressItem?.Pincode}   {addressItem?.AltPhoneNumber}
                  </h4>
                  <hr />
                  <div className="Edit-and-remove-address-main-container">
                    <div
                      className="col-lg-6 pro_add_text_center"
                      onClick={() => handleEditaddress(addressItem)}
                    >
                      <p>Edit</p>
                    </div>
                    <div
                      className="col-lg-6 pro_add_text_center"
                      onClick={() => handleRemoveDeliveryAddress(addressItem)}
                    >
                      <p>Remove</p>
                    </div>
                  </div>
                  <div className="use-shipping-address-heading">
                    <input
                      onClick={() => UpdateDefaultDeliveryAddress(addressItem)}
                      checked={addressItem?.IsDefault === true}
                      type="radio"
                      name="shippingAddress"
                    />
                    <p>Use this address for shipping</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Shipping Address{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container">
            <Form.Group controlId="formMobile">
              <Form.Label>
                Mobile Number <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter 10-digit mobile number"
                name="mobile"
                value={Address.mobile}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    mobile: e?.target?.value,
                  })
                }
                maxLength={10}
              />
            </Form.Group>
            <Form.Group controlId="formPincode">
              <Form.Label>
                Pincode <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter pincode"
                name="pincode"
                value={Address.pincode}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    pincode: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formAddress">
              <Form.Label>
                Address (Area and Street/House No.) <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your address"
                name="address"
                value={Address.address}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    address: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formLocality">
              <Form.Label>
                Locality <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter locality"
                name="locality"
                value={Address.locality}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    locality: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formCity">
              <Form.Label>
                City <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city"
                name="city"
                value={Address.city}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    city: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formState">
              <Form.Label>
                State <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter state"
                name="state"
                value={Address.state}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    state: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formLandmark">
              <Form.Label>Landmark (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter landmark (optional)"
                name="landmark"
                value={Address.landmark}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    landmark: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formAltPhone">
              <Form.Label>Alternative Phone Number (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter alternative phone number (optional)"
                name="altPhone"
                value={Address.altPhone}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    altPhone: e?.target?.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="Add-address-modal-save-button"
            variant="primary"
            onClick={handleAddAddress}
          >
            {!PrefiledData ? " Save Address" : "Update Address"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AddressDetails;
